/** @format */

export enum SocialContentDaoRequestKey {
	BYPRODUCTID = 'Social Content DAO By Product ID',
	BYPRODUCTURL = 'Social Content DAO By Product URL'
}

export enum SocialContentServiceRequestKey {
	BYPRODUCTID = 'Social Tagged Content By Product ID',
	BYPRODUCTURL = 'Social Tagged Content By Product Url'
}
